module.exports = __webpack_public_path__ + "img/5.38c60ff.webp";